<template>
  <v-layout>
    <v-flex class="search-location-select w-100">
      <v-select
              v-model="model"
              class="g-search-input"
              :items="groups"
              :placeholder="$t('products.select_group')"
              item-text="name"
              item-value="id"
              hide-details
              hide-selected
              clearable
              solo
              flat
              :ripple="false"
              prepend-inner-icon='group'
              :menu-props="{contentClass: 'select-dropdown',}"
              attach=".group-selection-box"
      >
        <template slot="no-data">
          <v-list-tile-content class="search-location-select-empty" v-text="$t('products.no_group_data')"></v-list-tile-content>
        </template>
      </v-select>
    </v-flex>
  </v-layout>
</template>

<script>
import {mapState} from 'vuex'
import {EventBus} from '../../event-bus'

export default {
  name: 'SelectByGroup',
  data () {
    return {
      model: null,
      clearable: true,
      groups: []
    }
  },
  computed: {
    ...mapState({
      userGroups: state => state.groups.userGroups
    })
  },
  created () {
    EventBus.$on('language-changed', this.languageChanged)
  },
  mounted () {
    this.getUserGroups()
  },
  watch: {
    model (val) {
      this.$emit('changeGroup', val)
    }
  },
  methods: {
    getUserGroups () {
      this.$store.dispatch('groups/getUserGroups').then(res => {
        if (res.groups.length) {
          this.getGroups()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getGroups () {
      let groups = this.userGroups
      var _groups = []
      if (groups.length) {
        _groups.unshift({name: this.$root.$t('products.all_groups'), id: 0})
        groups.forEach(group => {
          group.name = ''
          group.GroupTranslations.forEach(groupTranslation => {
            if (groupTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
              group.name = groupTranslation.name
            } else if (!group.name) {
              group.name = groupTranslation.name
            }
          })
          _groups.push(group)
        })
      }
      this.groups = _groups
    },
    languageChanged () {
      this.getGroups()
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/sass/desktop/products.scss";
</style>



// WEBPACK FOOTER //
// src/components/products/SelectByGroup.vue